module.exports = __webpack_public_path__ + "static/media/icon_8.bf1c7524.svg";